import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontClickEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {InfoBubblePillVariantsEnum} from '../../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

export const ResolvedStatusEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const {trackDataEvent} = useDataEventTracking();

  const onNextClick = (event: FrontClickEvent) => {
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.DEMO_TICKET_STATUS_RESOLVED, {});
    props.onNextClick(event);
  };

  return (
    <EducationTip
      anchor={props.anchor}
      position="bottom-start"
      isVisible={props.isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={<Trans id="infobubble-resolved-status-title">The conversation is now resolved!</Trans>}
      onPrimaryClick={onNextClick}
      primaryActionLabel={<Trans id="infobubble-resolved-status-primary">Got it</Trans>}
      dataObjectName={OnboardingDataEventObject.DEMO_TICKET_STATUS_RESOLVED}
      stepCounter={generateStepText(4, 4)}
    >
      <Trans id="infobubble-resolved-status-description">
        Your teammate has sent a response to the customer and marked the status as &quot;resolved&quot; -
        meaning no further action is needed at this time.
      </Trans>
    </EducationTip>
  );
};
